{
  "guidance": {
    "coaches": {
      "C03": {
        "title": "توريد احتياج",
        "summary": "افتح طلب عروض مسوّدة، وقارن ردود الموردين، وسجّل الترسية وفق صلاحياتك.",
        "welcome": {
          "title": "من طلب العروض إلى قرار التوريد",
          "body": "ابدأ بمسوّدة موجودة في قائمة التوريد. أنت تختار الموردين وتتخذ كل قرار، ولا ينفّذ هذا المرشد أي إجراء تجاري. إذا لم تجهّز المسوّدة بعد، أوقف المرشد مؤقتًا واستخدم نموذج طلب العروض المعتاد أولًا."
        },
        "open-draft": {
          "title": "افتح مسوّدة طلب العروض",
          "body": "افتح طلب عروض بحالة مسوّدة في هذه القائمة. اختر سجلًا تملك صلاحية إدارته؛ لا يختار المرشد سجلًا نيابةً عنك."
        },
        "requirement": {
          "title": "راجع الاحتياج والموعد النهائي",
          "body": "راجع ملخص المسوّدة والكميات المطلوبة والعملة والموعد النهائي للرد. فتح الطلب يدعو الموردين لتقديم عروض، ولا ينشئ أمر شراء ولا يلتزم بموازنة."
        },
        "invite": {
          "title": "اختر الموردين الذين ستدعوهم",
          "body": "راجع الموردين المتاحين لك. عندما يعيد المرشد التحكم إليك، اختر الموردين المناسبين للاحتياج. لا يقترح المرشد موردًا ولا يختار أي مورد."
        },
        "publish-handoff": {
          "title": "افتح طلب العروض بنفسك",
          "body": "ستختار الآن الموردين وتضغط فتح الطلب للموردين في الصفحة. راجع الاحتياج والموعد النهائي قبل التنفيذ.",
          "consequence": "يجعل الفتح طلب العروض متاحًا للموردين المدعوين ويخصّص رقمه المرجعي. ولا ينشئ أمر شراء."
        },
        "publish": {
          "title": "بانتظار فتحك لطلب العروض",
          "body": "اختر الموردين واستخدم إجراء فتح الطلب للموردين في الصفحة. ينتظر المرشد قبول الخادم؛ وإذا رُفض الإجراء تبقى في هذه الخطوة.",
          "blocked": "اختر موردًا مؤهلًا واحدًا على الأقل في هذه المسوّدة. إذا رفضت الصفحة الفتح، اتبع التوضيح وأعد محاولة الإجراء نفسه."
        },
        "compare": {
          "title": "قارن ردود الموردين الفعلية",
          "body": "قارن السعر وصلاحية العرض والحد الأدنى للكمية ومدة التوريد والتوافر. لا يوجد فائز تلقائي. إذا لم يصل عرض مناسب، أوقف المرشد مؤقتًا وعُد بعد وصول الردود؛ لا تُرسِ عرضًا غير مناسب لمجرد إكمال المرشد."
        },
        "award-handoff": {
          "title": "اختر العرض وسجّل الترسية بنفسك",
          "body": "ستختار الآن عرضًا ساريًا وتوضح قرارك وتستخدم إجراء الترسية في الصفحة. الإغلاق دون ترسية نتيجة تجارية مختلفة، ولا يعرضها المرشد على أنها ترسية.",
          "consequence": "تسجّل الترسية اختيارك المصرّح به وتُنشئ اتفاقية إطارية مسودة لوحدة الشراء التي جاء منها الاحتياج. ولا تنشئ أمر شراء ولا تلتزم بموازنة؛ ويفعّلها من يملك صلاحية الاتفاقيات قبل أن يُشترى شيء، ويتبع أي شراء مسار الطلب وأمر الشراء المعتاد."
        },
        "award": {
          "title": "بانتظار قرار الترسية منك",
          "body": "اختر ردًا ساريًا واكتب سببًا واضحًا للترسية، ثم اضغط إجراء الترسية بنفسك. لا يتقدّم المرشد إلا بعد تأكيد الصفحة قرار الخادم.",
          "blocked": "اختر ردًا ساريًا واكتب السبب الذي تطلبه الصفحة. لا تُرسِ عرضًا منتهيًا أو غير مناسب؛ أوقف المرشد مؤقتًا إذا احتجت إلى رد آخر."
        },
        "result": {
          "title": "تحقّق من نتيجة التوريد",
          "body": "تحقّق من أن طلب العروض يعرض حالة تمت الترسية وراجع الاتفاقية المسودة التي أنشأها: أين تنطبق وحتى متى. يظل تفعيلها ورفع طلب شراء إجراءين منفصلين وفق الصلاحيات."
        },
        "finish": {
          "title": "اكتمل مرشد التوريد",
          "body": "أنت نفّذت الفتح والترسية، والمرشد راقب نتيجتيهما المقبولتين فقط. يسجّل الإنهاء تقدّم المرشد وحده، ولا يسجّل قبولًا تجاريًا."
        }
      },
      "C04": {
        "title": "إدارة أمر شراء",
        "summary": "راجع مسوّدة أمر، وأصدرها، وأرسل الإصدار الحالي، وتعرّف إلى المسؤولين عن الخطوات التالية.",
        "welcome": {
          "title": "من المسوّدة إلى تسليم المورد",
          "body": "ابدأ بمسوّدة أمر موجودة تملك صلاحية إصدارها وإرسالها. أنت تنفّذ الإجراءين. لا يُصدر المرشد أو يُرسل أو يُعدّل أمرًا، ولا يسجّل استلامًا أو فاتورة."
        },
        "open-draft": {
          "title": "افتح مسوّدة أمر الشراء",
          "body": "افتح أمرًا بحالة مسوّدة من القائمة. إذا كان الأمر صادرًا بالفعل، استخدم مسوّدة أخرى لهذا المسار أو استأنف مرشدًا موجودًا من خطوته المسجّلة."
        },
        "terms": {
          "title": "راجع الأمر قبل الالتزام",
          "body": "تحقّق من المورد وموقع التسليم والأصناف والكميات والأسعار والعملة والإجماليات. المسوّدة ليست التزامًا تجاريًا بعد."
        },
        "status": {
          "title": "اقرأ أبعاد الحالة الأربعة منفصلة",
          "body": "تجيب دورة الحياة ورد المورد والتنفيذ ومستندات الفاتورة عن أسئلة مختلفة. إصدار الأمر لا يعني قبول المورد أو وصول البضاعة أو تسجيل فاتورة."
        },
        "issue-handoff": {
          "title": "أصدر أمر الشراء بنفسك",
          "body": "ستضغط الآن إجراء الإصدار في الصفحة بعد مراجعة المسوّدة. لا يضغط المرشد الزر نيابةً عنك.",
          "consequence": "يخصّص الإصدار رقمًا للأمر، ويثبّت نسخته التجارية الحالية، ويلتزم بالموازنة المطبّقة. ولا يسجّل استلامًا أو دفعًا."
        },
        "issue": {
          "title": "بانتظار إصدار الأمر منك",
          "body": "استخدم إجراء الإصدار في الصفحة. ينتظر المرشد نتيجة الخادم المقبولة وحالة الإصدار. إذا رفض الخادم، صحّح السبب الموضّح في الصفحة وأعد المحاولة."
        },
        "send-handoff": {
          "title": "أرسل الإصدار الحالي بنفسك",
          "body": "ستستخدم الآن إرسال للمورد في الصفحة. على الهاتف، افتح إجراءات أخرى للعثور عليه. تحقّق من أنك ترسل الإصدار المقصود.",
          "consequence": "يرسل الإجراء الإصدار الحالي من أمر الشراء عبر مسار إشعار المورد الموجود. ولا يُعدّ قبولًا من المورد أو استلامًا للبضاعة."
        },
        "send": {
          "title": "بانتظار إرسالك إلى المورد",
          "body": "استخدم إرسال للمورد بنفسك؛ يوجد على الهاتف ضمن إجراءات أخرى. ينتظر المرشد نجاح الإرسال لدى الخادم وتسجيل وقت الإرسال. ولا يتقدّم عند الرفض."
        },
        "responses": {
          "title": "تابع رد المورد",
          "body": "يستطيع المورد التأكيد أو الاستفسار أو الرفض أو بيان التوافر عبر قناته. اقرأ الرد الفعلي وأي استثناء. يظل رد المورد منفصلًا عن الاستلام؛ ويسجّل المستلِم التسليم."
        },
        "versions": {
          "title": "حافظ على وضوح المستندات التجارية",
          "body": "راجع سجل الإصدارات الصادرة. يستخدم أي تعديل أو إلغاء أو استلام أو مستند فاتورة لاحق مساره المصرّح به، ولا يغيّر المرشد أيًّا منها."
        },
        "finish": {
          "title": "اكتمل مرشد أمر الشراء",
          "body": "أنت أصدرت أمر الشراء وأرسلته. يسجّل الإنهاء تقدّم المرشد فقط. يظل رد المورد والتسليم ومستند الفاتورة والدفع حقائق منفصلة."
        }
      }
    }
  }
}
